import React, {useEffect} from 'react';
import Pride from 'react-canvas-confetti/dist/presets/pride'
import randomInRange from 'react-canvas-confetti/dist/helpers/randomInRange'
import useSound from 'use-sound';
import {Colors} from '../../../Utils/styles/Colors';
import './Confetti.scss';

const soundUrl =  `${process.env.REACT_APP_PUBLIC_FILES_URL}/sounds/hand-clap.mpeg`; // replace with the path to your sound file
export const Confetti = ({stopSoundAfter= 5000, showConfetti, stopConfettiAfter = 1500}) => {
    const [play, { stop }] = useSound(soundUrl, { volume: 1 });

    const palette = [
        Colors['$themeLight'],
        Colors['$menuButton'],
        Colors['$completedColor'],
        Colors['$subTitle']
    ];

    useEffect(() => {
        if (showConfetti) {
            play(); // Play the sound when confetti starts
            setTimeout(() => {
                stop(); // Stop sound after the specified time
            }, stopSoundAfter);
        } else {
            stop();
        }
        // Clean up the sound when component unmounts
        return () => {
            stop();
        };
    }, [showConfetti, play, stop]);


    if(showConfetti){
        return <div className="confetti-wrapper">
            <Pride autorun={{ speed: 15, duration: stopConfettiAfter}}
                   decorateOptions={(defaultOptions) => ({
                       ...defaultOptions,
                       colors: palette,
                       scalar: randomInRange(0.8, 2),
                       particleCount: randomInRange(1, 20),
                       startVelocity: randomInRange(60, 80),
                       gravity: 1,
                       origin: { ...defaultOptions.origin, y: 1 }
                   })} />
        </div>
    }

    return null
};